import { notification } from 'antd'
import React from 'react'
import { NOTIFICATION_ACTIONS, NOTIFICATION_TYPES } from '../constants/notification-types'
import MbaUpgradeActions from '../components/common/notifications/actions/MbaUpgradeActions'

export const openNotificationWithIcon = (type, message, description, key, actions) => {
    notification[type]({
        key: key || message,
        message: <div dangerouslySetInnerHTML={{ __html: message }} />,
        description: description,
        btn: actions,
    })
}

export const getNotificationType = type => {
    if (type === NOTIFICATION_TYPES.SUCCESS) {
        return 'success'
    } else if (type === NOTIFICATION_TYPES.WARNING) {
        return 'warning'
    } else if (type === NOTIFICATION_TYPES.ERROR) {
        return 'error'
    } else {
        return 'info'
    }
}

export const messageStrategies = {
    [NOTIFICATION_ACTIONS.MBA_UPGRADE]: payload =>
        `New version (${payload.new_version_name}) of the ${payload.mba_name} MBA is available. Consider upgrading to get the latest improvements.`,
    default: () => 'Unknown notification type',
}

export const getMessageFromType = (type, payload) => (messageStrategies[type] || messageStrategies.default)(payload)

export const actionStrategies = {
    [NOTIFICATION_ACTIONS.MBA_UPGRADE]: payload => (
        <MbaUpgradeActions token={payload.mba_token} versionId={payload.new_version_id} />
    ),
    default: () => null,
}

export const getActionsFromType = (type, payload) => (actionStrategies[type] || actionStrategies.default)(payload)
